function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { KEY_ARROW_DOWN, KEY_ARROW_LEFT, KEY_ARROW_RIGHT, KEY_ARROW_UP, VOLUME_MAX, VOLUME_MIN, VOLUME_STEP } from "@config/constants";
import React, { Component } from "react";
var VolumeSlider = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(VolumeSlider, Component);
    var _super = _create_super(VolumeSlider);
    function VolumeSlider(props) {
        _class_call_check(this, VolumeSlider);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            isTriggeredFromKeyboard: false
        };
        _this.handleChange = _this.handleChange.bind(_assert_this_initialized(_this));
        _this.handleKeyDown = _this.handleKeyDown.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(VolumeSlider, [
        {
            /**
     * Change volume form slider
     * @param event {Object}
     * @param isTriggeredFromKeyboard {boolean}
     */ key: "handleChange",
            value: function handleChange(event, isTriggeredFromKeyboard) {
                this.props.onVolumeChange(event, isTriggeredFromKeyboard);
            }
        },
        {
            /**
     * Sets the flag for volume changed from keyboard
     * @param event
     */ key: "handleKeyDown",
            value: function handleKeyDown(event) {
                var key = event.which;
                if (key === KEY_ARROW_LEFT || key === KEY_ARROW_RIGHT || key === KEY_ARROW_DOWN || key === KEY_ARROW_UP) {
                    event.stopPropagation();
                    this.setState({
                        isTriggeredFromKeyboard: true
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                // Make volume percentage
                var currentPosition = "".concat(this.props.volume * 100, "%");
                return /*#__PURE__*/ _jsxs("div", {
                    className: "volume-slider".concat(this.props.isSliderShown ? " active" : ""),
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "current",
                            style: {
                                width: currentPosition
                            }
                        }),
                        /*#__PURE__*/ _jsx("input", {
                            type: "range",
                            min: VOLUME_MIN,
                            max: VOLUME_MAX,
                            tabIndex: "0",
                            value: this.props.volume,
                            step: VOLUME_STEP,
                            onKeyDown: this.handleKeyDown,
                            onMouseDown: function() {
                                return _this.setState({
                                    isTriggeredFromKeyboard: false
                                });
                            },
                            onChange: function(event) {
                                return _this.handleChange(event, _this.state.isTriggeredFromKeyboard);
                            }
                        })
                    ]
                });
            }
        }
    ]);
    return VolumeSlider;
}(Component);
export default VolumeSlider;
